import { subPartyDeleteApi } from "../../api/subParty/subPartyDeleteApi"

export async function subPartyDeleteService(payload: { id: string }, token: string) {
	return await subPartyDeleteApi(payload, token)
}
